module.exports = __webpack_public_path__ + "static/media/1POLICY16.0278db3b.jpg";